import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=04520d34&scoped=true&"
import script from "./BaseAlert.vue?vue&type=script&lang=ts&"
export * from "./BaseAlert.vue?vue&type=script&lang=ts&"
import style0 from "./BaseAlert.vue?vue&type=style&index=0&id=04520d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04520d34",
  null
  
)

export default component.exports